const { failProofAssign } = require('../utils');

class Report {
  constructor(obj) {
    obj && failProofAssign(this, obj);
  }

  getMetric() {
    return this.metric;
  }

  getJSON() {
    return { ...this };
  }
}

module.exports = Report;
